@use "styles" as *;
@use "sass:map";

$parent-block: me-accordion;
$item-block: me-accordion-item;

.#{$parent-block} {
  display: block;
  overflow: hidden;

  @each $theme, $theme-options in $accordion-themes {
    &--#{$theme} {
      @if map.get($theme-options, border-type) == around {
        border: 1px solid map.get($theme-options, border-color);
        border-radius: $border-radius;
      }
      @else if map.get($theme-options, border-type) == top-bottom {
        border-bottom: 1px solid map.get($theme-options, border-color);
      }

      & .#{$item-block} {
        @if map.get($theme-options, border-type) == between {
          &:last-of-type {
            border-bottom: 1px solid map.get($theme-options, border-color);
          }
        }
        @else if map.get($theme-options, border-type) == around {
          &:first-of-type {
            border-top: none;
          }
        }

        border-color: map.get($theme-options, border-color);

        &__header {
          text-transform: map.get($theme-options, text-transform);
          font-weight: map.get($theme-options, font-weight);
          padding: map.get($theme-options, padding);
          color: map.get($theme-options, color);
        }

        &__icon {
          @if map.get($theme-options, border-type) == between {
            border-left: 1px solid;
          }

          color: map.get($theme-options, icon-color);
          border-color: map.get($theme-options, border-color);
          padding: map.get($theme-options, icon-padding);
        }

        &__main {
          padding: map.get($theme-options, main-padding);
        }

        &__content-padding {
          padding-top: map.get($theme-options, gap);
          padding-left: map.get($theme-options, inset);

          > [slot="content"] {
            @include remove-first-and-last-child-margins;
          }
        }
      }
    }
  }
}
